<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui/src";
	import SalesIncomes from "@hitit/hub/src/v7/components/dashboard/SalesIncomes.svelte";
	import RangePresets from "@hitit/hub/src/v7/components/common/RangePresets.svelte";
	import DateRange from "@hitit/hub/src/v7/components/common/DateRange.svelte";
	import Pecktime from "@hitit/hub/src/v7/components/dashboard/Pecktime.svelte";
	import DiscountRedeemdTrend from "@hitit/hub/src/v7/components/dashboard/DiscountRedeemdTrend.svelte";
	import SalesChart from "@hitit/hub/src/v7/components/dashboard/SalesChart.svelte";
	import SalesItemRanking from "@hitit/hub/src/v7/components/dashboard/SalesItemRanking.svelte";
	import VisitTrend from "@hitit/hub/src/v7/components/dashboard/VisitTrend.svelte";
	import EarnedTrend from "@hitit/hub/src/v7/components/dashboard/EarnedTrend.svelte";
	import RedeemedTrend from "@hitit/hub/src/v7/components/dashboard/RedeemedTrend.svelte";
	//Utils
	import { endOfDay, startOfDay } from "date-fns";
	import { api, notifications, t } from "@hitit/hub/src/stores";
	import { onDestroy } from "svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	//Types
	type RangeHandlerEvent = { detail: { start: Date; end: Date } };
	//Props
	export let storeId: string = "";
	export let today = startOfDay(new Date());
	export let range = {
		start: startOfDay(new Date()),
		end: endOfDay(new Date()),
	};
	//Constants
	//Variables
	let hasPointSetting = false;
	//Functions
	function rangeHandler(e: RangeHandlerEvent) {
		const { start, end } = e.detail;
		range = { start, end: endOfDay(end) };
	}

	async function getPointSetting(storeId: string) {
		try {
			const { data } = await $api.getPointSetting(storeId);
			hasPointSetting = data.setting.pointType === "POINT";
		} catch (error) {
			notifications.append(
				"ERROR",
				$t("sso.error.unknownError"),
				"",
				undefined,
				"WARNING"
			);
			hasPointSetting = false;
			console.log(error);
		}
	}
	//Do
	$: getPointSetting(storeId);
	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	<SalesIncomes storeIds={[storeId]} today={today} />
	<div class="date-range-container">
		<RangePresets today={today} range={range} on:change={rangeHandler} />
		<DateRange range={range} on:change={rangeHandler} />
	</div>
	<div class="chart-container same-width sales-discount">
		<div class="chart-box">
			<Card noPadding>
				<SalesChart range={range} storeIds={[storeId]} />
			</Card>
		</div>
		<div class="chart-box">
			<Card noPadding>
				<DiscountRedeemdTrend range={range} storeIds={[storeId]} />
			</Card>
		</div>
	</div>
	<div class="chart-container same-width pick-item">
		<div class="chart-box picktime">
			<Card noPadding>
				<Pecktime range={range} storeIds={[storeId]} />
			</Card>
		</div>
		<div class="chart-box ranking">
			<Card noPadding>
				<SalesItemRanking range={range} storeIds={[storeId]} />
			</Card>
		</div>
	</div>
	{#if hasPointSetting}
		<div class="chart-container point">
			<div class="chart-box visit-trend">
				<Card noPadding>
					<VisitTrend range={range} storeIds={[storeId]} />
				</Card>
			</div>
			<div class="chart-box point-trend">
				<Card noPadding>
					<EarnedTrend range={range} storeIds={[storeId]} />
				</Card>
			</div>
			<div class="chart-box point-trend">
				<Card noPadding>
					<RedeemedTrend range={range} storeIds={[storeId]} />
				</Card>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding-top: 50px;

		.date-range-container {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
		}

		.chart-container {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 10px;
			&.sales-discount {
				.chart-box {
					height: 505px;
				}
			}
			&.pick-item {
				.picktime {
					height: 640px;
				}
				.ranking {
					height: 918px;
				}
			}

			&.same-width {
				.chart-box {
					width: 100%;
				}
			}

			&.point {
				.chart-box {
					width: 100%;
				}

				.visit-trend {
					height: 412px;
				}
				.point-trend {
					height: 426px;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 30px;
			padding-top: 0;

			.chart-container {
				flex-direction: row;
				gap: 20px;
				&.saels-discount {
					.chart-box {
						height: 600px;
					}
				}
				&.pick-item {
					.picktime {
						height: 960px;
					}
					.ranking {
						height: 960px;
					}
				}

				&.same-width {
					.chart-box {
						width: calc(50% - 10px);
					}
				}
				&.point {
					.visit-trend {
						min-width: 200px;
						max-width: 300px;
						width: max-content;
						height: 498px;
						flex-basis: calc(100% * (298 / 1558));
						flex-grow: 298;
					}
					.point-trend {
						width: max-content;
						height: 498px;
						flex-basis: calc(100% * (628 / 1558));
						flex-grow: 628;
					}
				}
			}
		}
	}

</style>
